module.exports = __webpack_public_path__ + "static/img/dna-signature.b32d306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paternitytesting/dna-signature.jpg
// module id = VZ5q
// module chunks = 0